module.exports = __webpack_public_path__ + "img/20180120_8.68c0498f.jpeg";